// E9.9: RoomMembersPanel 里 AI chip 下方的 quota 进度条.
// 数据源: lib/quota-bus.ts (EOF 帧推送), 没数据时不渲染.

import { useQuotaSnapshot } from "../lib/quota-bus";

interface Props {
  adapterId: string;
}

export function AgentQuotaBar({ adapterId }: Props) {
  const snap = useQuotaSnapshot(adapterId);
  if (!snap) return null;

  // 优先显示日 token (限额最常见). 若无日 token 限额, 退而求其次显示日 USD / 总 USD.
  const dayTok = pick(snap.day_tokens_used, snap.day_tokens_limit);
  const dayUsd = pick(snap.day_usd_used, snap.day_usd_limit);
  const totUsd = pick(snap.total_usd_used, snap.total_usd_limit);

  const primary = dayTok ?? dayUsd ?? totUsd;
  if (!primary) return null;

  const pct = Math.min(100, Math.round((primary.used / primary.limit) * 100));
  const cls =
    pct >= 100 ? "quota-bar quota-bar--full"
      : pct >= 80 ? "quota-bar quota-bar--warn"
      : "quota-bar";

  return (
    <div className={cls} title={primary.title}>
      <div className="quota-bar__track">
        <div className="quota-bar__fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="quota-bar__text muted small">
        {pct}% · {primary.label}
      </div>
    </div>
  );
}

function pick(
  used: number,
  limit: number | null,
):
  | { used: number; limit: number; label: string; title: string }
  | null {
  if (limit === null || limit <= 0) return null;
  // 类型推断: 都是 number, label/title 用整数判断走 token 还是 USD
  if (Number.isInteger(used) && Number.isInteger(limit) && limit > 100) {
    // token 模式 (整数, 量级一般 > 100)
    return {
      used,
      limit,
      label: `${formatTokens(used)} / ${formatTokens(limit)} tokens`,
      title: `今日已用 ${used.toLocaleString()} / ${limit.toLocaleString()} tokens`,
    };
  }
  return {
    used,
    limit,
    label: `$${used.toFixed(3)} / $${limit.toFixed(2)}`,
    title: `今日已花 $${used.toFixed(4)} / $${limit.toFixed(2)}`,
  };
}

function formatTokens(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}k`;
  return String(n);
}
